import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';

import { Container, ProductItem } from './styles';

export default function Sidebar({ data, product }) {
  function formatMoney(value = 0) {
    const decimalCount = 2;
    const decimal = ',';
    const thousands = '.';

    let amount = value;
    const negativeSign = amount < 0 ? '-' : '';
    const i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)), 0).toString();
    const j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign
      + (j ? i.substr(0, j) + thousands : '')
      + i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`)
      + (decimalCount
        ? decimal
          + Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
        : '')
    );
  }
  return (
    <Container>
      <ProductItem to="/all" active={product === 'all' && true}>
        <div>
          <span>Todos</span>
          <em>R$ {formatMoney(data.balances.all.total || 0)}</em>
        </div>
        <Icon type="right" />
      </ProductItem>
      <ProductItem to="/nxt1" active={product === 'nxt1' && true}>
        <div>
          <span>Nxt1</span>
          <em>R$ {formatMoney(data.balances.nxt1.total || 0)}</em>
        </div>
        <Icon type="right" />
      </ProductItem>
      <ProductItem to="/qesh" active={product === 'qesh' && true}>
        <div>
          <span>Qesh</span>
          <em>R$ {formatMoney(data.balances.qesh.total || 0)}</em>
        </div>
        <Icon type="right" />
      </ProductItem>
      <ProductItem to="/faemg" active={product === 'faemg' && true}>
        <div>
          <span>Faemg</span>
          <em>R$ {formatMoney(data.balances.faemg.total || 0)}</em>
        </div>
        <Icon type="right" />
      </ProductItem>
      <ProductItem to="/faeb" active={product === 'faeb' && true}>
        <div>
          <span>Faeb</span>
          <em>R$ {formatMoney(data.balances.faeb.total || 0)}</em>
        </div>
        <Icon type="right" />
      </ProductItem>
      <ProductItem to="epar" active={product === 'epar' && true}>
        <div>
          <span>Epar</span>
          <em>R$ {formatMoney(data.balances.epar.total || 0)}</em>
        </div>
        <Icon type="right" />
      </ProductItem>
    </Container>
  );
}

Sidebar.propTypes = {
  product: PropTypes.string,
  data: PropTypes.shape({
    balances: PropTypes.shape({
      all: PropTypes.shape({
        total: PropTypes.number,
      }),
      nxt1: PropTypes.shape({
        total: PropTypes.number,
      }),
      qesh: PropTypes.shape({
        total: PropTypes.number,
      }),
      faemg: PropTypes.shape({
        total: PropTypes.number,
      }),
      faeb: PropTypes.shape({
        total: PropTypes.number,
      }),
      epar: PropTypes.shape({
        total: PropTypes.number,
      }),
    }),
  }).isRequired,
};

Sidebar.defaultProps = {
  product: 'all',
};
